import {FindByTypes} from "../TripsFilter/TripsFilterTypes";
import { Policies } from "../Shared/Permissions/Policies";

export const searchBarFindByTypes = [
    {
        key: FindByTypes[FindByTypes.OrderNumber],
        value: "Order Number",
        requiresAnyPolicy: [Policies.ViewOrders]
    },
    {
        key: FindByTypes[FindByTypes.TripNumber],
        value: "Trip Number",
        requiresAnyPolicy: [Policies.ViewOrders, Policies.ViewTrips]
    },
    {
        key: FindByTypes[FindByTypes.PatientName],
        value: "Patient Name",
        requiresAnyPolicy: [Policies.ViewOrders]
    },
    {
        key: FindByTypes[FindByTypes.DriverName],
        value: "Driver Name",
        requiresAnyPolicy: [Policies.ViewOrders, Policies.ViewTrips]
    },
    {
        key: FindByTypes[FindByTypes.OrderReference],
        value: "Order Reference",
        requiresAnyPolicy: [Policies.ViewOrders]
    },
    {
        key: FindByTypes[FindByTypes.DeliveryNumber],
        value: "Delivery Number",
        requiresAnyPolicy: [Policies.ViewOrders]
    }
];
